// src/App.js
import React, { useState } from 'react'; // <-- Tambahkan useState
// import AuthContext from './context/AuthContext';
import { Routes, Route } from 'react-router-dom';
import './App.css';

// Import Halaman
import LoginPage from './pages/LoginPage';
import JadwalServisPage from './pages/JadwalServisPage';
import RiwayatServisPage from './pages/RiwayatServisPage';
import DashboardPage from './pages/DashboardPage';
import KendaraanPage from './pages/KendaraanPage';
import PenggunaKendaraanPage from './pages/PenggunaKendaraanPage';
import EbookPage from './pages/EbookPage';
import ManageUsersPage from './pages/ManageUsersPage';
import LaporanPage from './pages/LaporanPage';
import EditProfilePage from './pages/EditProfilePage';

import RegisterPage from './pages/RegisterPage';
import OtpVerificationPage from './pages/OtpVerificationPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ServiceResponsePage from './pages/ServiceResponsePage';
import ServiceResponsesPage from './pages/ServiceResponsesPage';

import ProtectedRoute from './components/ProtectedRoute';
import RoleBasedRoute from './components/RoleBasedRoute';

const PlaceholderPage = ({ title }) => <div className="page-container"><h1>{title}</h1></div>;

function App() {

  // const { user } = useContext(AuthContext);
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  const closeSidebar = () => {
    if (isSidebarOpen) {
      setSidebarOpen(false);
    }
  };

  return (
    <>
      {isSidebarOpen && <div className="mobile-overlay" onClick={closeSidebar}></div>}
      <Routes>
        {/* Rute Publik */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/verify-otp" element={<OtpVerificationPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/service-response/:token" element={<ServiceResponsePage />} />

        <Route element={<ProtectedRoute />}>
          {/* Rute untuk SEMUA role yang sudah login */}
          <Route path="/" element={<DashboardPage />} />
          <Route path="/e-book" element={<EbookPage />} />
          <Route path="/edit-profile" element={<EditProfilePage />} />
          <Route path="/jadwal-servis" element={<JadwalServisPage />} />

          {/* Rute HANYA untuk Superadmin & Operator */}
          <Route element={<RoleBasedRoute allowedRoles={['superadmin', 'operator']} />}>
            <Route path="/kendaraan" element={<KendaraanPage />} />
            <Route path="/pengguna-kendaraan" element={<PenggunaKendaraanPage />} />
            <Route path="/riwayat-servis" element={<RiwayatServisPage />} />
            <Route path="/service-responses" element={<ServiceResponsesPage />} />
          </Route>

          {/* Rute HANYA untuk Superadmin */}
          <Route element={<RoleBasedRoute allowedRoles={['superadmin']} />}>
            <Route path="/laporan" element={<LaporanPage />} />
            <Route path="/manage-users" element={<ManageUsersPage />} />
          </Route>

          <Route path="*" element={<PlaceholderPage title="404 Halaman Tidak Ditemukan" />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;